<template>
  <b-form-group
    :label="label"
    label-for="password-input"
    class="bold-label"
    :state="password.state"
    :invalid-feedback="password.invalidFeedback">
    <div class="password-line">
      <b-input-group>
        <b-form-input
          id="password-input"
          v-model="password.value"
          :type="showPassword ?'text' : 'password'"
          :state="password.state"
          v-on:change="removeInvalidFeedback"
          required>
        </b-form-input>
        <b-input-group-append>
          <div class="eye-button form-control" @click="togglePassword" >
            <eye-icon v-if="!showPassword"></eye-icon>
            <eye-off-icon v-else></eye-off-icon>
          </div>
        </b-input-group-append>
      </b-input-group>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: 'PasswordField',

  props: {
    password: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: function () {
        return this.$t('Password')
      }
    }
  },

  data () {
    return {
      showPassword: false
    }
  },

  methods: {
    togglePassword () {
      this.showPassword = !this.showPassword
    },

    removeInvalidFeedback () {
      this.password.state = null
      this.password.invalidFeedback = null
    }
  }
}
</script>

<style scoped>

.password-line{
  display: flex;
  flex-direction: row;
}

#password-input {
  border-right: none;
}

.eye-button {
  border: 1px solid var(--main-border-color) !important;
  border-left: none;
  border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0;
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-color) !important;
  background-color: var(--background-grey) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/PasswordField.vue